import { gqlClient } from "@/util/graphql"
import { redirectToLogin } from "@/util/url"
import { Avatar, Box, Fade, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material"
import React from "react"
import { BiLinkExternal, BiLogOut } from "react-icons/bi"

export const Header = () => {
	const email = localStorage.getItem("email")
	const [anchorEl, setAnchorEl] = React.useState<undefined | HTMLElement>()
	const isOpen = Boolean(anchorEl)
	const onClickUser = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(undefined)
	}
	const logout = async () => {
		await gqlClient()
			.logout()
			.finally(() => {
				handleClose()
			})

		// ログアウト（localStorageにある情報を削除することでログアウトできる）
		localStorage.removeItem("userId")
		localStorage.removeItem("officeId")
		localStorage.removeItem("name")
		localStorage.removeItem("email")
		// ログインページへ移動
		location.href = redirectToLogin()
	}

	function openFront() {
		handleClose()
		window.open(import.meta.env.VITE_APP_FRONT_URL, "_blank")
	}

	return (
		<Box
			sx={{
				bgcolor: "primary.main",
				padding: "4px 8px 4px 4px",
				color: "white",
				textAlign: "right",
				width: "100vw",
				position: "fixed",
				top: 0,
				right: 0,
				zIndex: "appBar",
			}}
		>
			<IconButton
				onClick={onClickUser}
				size="small"
				aria-controls={isOpen ? "account-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={isOpen ? "true" : undefined}
				sx={{ color: "white" }}
			>
				<Avatar sx={{ width: 24, height: 24, "margin-right": "8px" }} />
				{email}
			</IconButton>
			<Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose} TransitionComponent={Fade}>
				<MenuItem onClick={openFront}>
					<ListItemIcon>
						<BiLinkExternal />
					</ListItemIcon>
					最適ワークス
				</MenuItem>
				<MenuItem onClick={logout}>
					<ListItemIcon>
						<BiLogOut />
					</ListItemIcon>
					ログアウト
				</MenuItem>
			</Menu>
		</Box>
	)
}
